var _defs, _path, _path2, _rect, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMp3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ba5439ca-0886-4aaf-96fc-f08ceadd5607",
    "data-name": "\\u5716\\u5C64 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ae0a30a0-0ba9-4b61-a11e-91a78b7b0c77,.aee7f1d7-5961-4b66-a7d2-ae0ffbb2e652{fill:none;}.ae0a30a0-0ba9-4b61-a11e-91a78b7b0c77,.bc9a68f8-26d4-4e94-bfcf-3b620be32a02{stroke:#8e8e8e;stroke-width:2px;}.ae0a30a0-0ba9-4b61-a11e-91a78b7b0c77,.aee7f1d7-5961-4b66-a7d2-ae0ffbb2e652,.bc9a68f8-26d4-4e94-bfcf-3b620be32a02{stroke-linecap:round;stroke-linejoin:round;}.bc9a68f8-26d4-4e94-bfcf-3b620be32a02,.eeb4eb81-cce9-4907-9d2b-77a69090033b{fill:#68b21d;}.a3f37a30-5ff7-4e58-b7b9-00ef4eea2598{fill:#fff;}.aee7f1d7-5961-4b66-a7d2-ae0ffbb2e652{stroke:#645346;stroke-width:3px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mp3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ae0a30a0-0ba9-4b61-a11e-91a78b7b0c77",
    d: "M22,78.3a4.2,4.2,0,0,0,4.2,4.2H67.7a4.2,4.2,0,0,0,4.2-4.2V21.2A4.2,4.2,0,0,0,67.7,17h-31L22,31.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "bc9a68f8-26d4-4e94-bfcf-3b620be32a02",
    d: "M22,31.7H32.4a4.2,4.2,0,0,0,4.3-4.2V17Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "eeb4eb81-cce9-4907-9d2b-77a69090033b",
    x: 32.7,
    y: 59.4,
    width: 45.5,
    height: 15.18,
    rx: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a3f37a30-5ff7-4e58-b7b9-00ef4eea2598",
    d: "M50.7,67.9c-.1-1.4-.2-3.1-.2-4.4h0l-1.3,3.9-1.8,4.9h-1l-1.7-4.8c-.5-1.5-.9-2.8-1.2-4h0c0,1.3-.1,3-.2,4.5L43,72.4H41.8l.7-10.2h1.7l1.7,4.9L47,70.5h0c.3-1,.6-2.1,1.1-3.4l1.8-4.9h1.7l.6,10.2H50.9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a3f37a30-5ff7-4e58-b7b9-00ef4eea2598",
    d: "M54.3,62.3l2.5-.2a4.6,4.6,0,0,1,2.9.8,3.2,3.2,0,0,1,.9,2.2,3.3,3.3,0,0,1-.8,2.2,4.6,4.6,0,0,1-3.2,1.1h-1v4.1H54.3Zm1.3,4.9h1.1c1.6,0,2.5-.8,2.5-2.2s-.9-2-2.4-2H55.6Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a3f37a30-5ff7-4e58-b7b9-00ef4eea2598",
    d: "M62.2,70.9a4.9,4.9,0,0,0,2.2.6,1.9,1.9,0,0,0,2.2-1.9c0-1.4-1.3-2-2.6-2h-.7v-1H64c1,0,2.2-.5,2.2-1.7s-.5-1.5-1.7-1.5a4,4,0,0,0-2,.7l-.3-1a4.5,4.5,0,0,1,2.6-.7c1.9,0,2.8,1.1,2.8,2.3A2.4,2.4,0,0,1,65.8,67h0A2.5,2.5,0,0,1,68,69.6c0,1.6-1.3,3-3.6,3a5.4,5.4,0,0,1-2.6-.7Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "aee7f1d7-5961-4b66-a7d2-ae0ffbb2e652",
    d: "M49,33.9l-5.4,5.4H37.4A1.4,1.4,0,0,0,36,40.7v8.7a1.5,1.5,0,0,0,1.4,1.5h6.2L49,56.2a1.4,1.4,0,0,0,2.5-1V34.9A1.5,1.5,0,0,0,49,33.9Zm7.4,6.5a1.5,1.5,0,0,0-2,.6,1.6,1.6,0,0,0,.6,2,2.3,2.3,0,0,1,1.3,2.1A2.6,2.6,0,0,1,55,47.2a1.5,1.5,0,0,0-.6,1.9,1.5,1.5,0,0,0,2,.6,5.3,5.3,0,0,0,2.8-4.6A5.4,5.4,0,0,0,56.4,40.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp3);
export default __webpack_public_path__ + "static/media/mp3.1481a055109c666b0d80457bdd0fbdc2.svg";
export { ForwardRef as ReactComponent };